(function autorun() {
 var appElements = document.getElementsByClassName("App");

for (var i = 0; i < appElements.length; i++) {
  appElements[i].classList.add("page-width");
}
})();

function openCustomization(id, title, price, img) {
  var popup = document.getElementById("custom-popup");
console.log(img);
  if (popup.style.display === "block") {
    popup.style.display = "none";
  } else {
    popup.style.display = "block";
  }

  // Save id, title, and empty tabName array to local storage in JSON format
  var data = { id: id, title: title,price: price, tabName: [] }; // Initialize tabName as an empty array
  localStorage.setItem("customData", JSON.stringify(data));

  console.log("open");
}

function toggleCustomization(colorId, btnId, tabName, price) {
  var colorElement = document.getElementById(colorId);
  var btnElement = document.getElementById(btnId);

  // Retrieve the stored data from localStorage
  var storedData = JSON.parse(localStorage.getItem("customData")) || {};

  if (btnElement.textContent === "Remove") {
    btnElement.textContent = "Select";
    colorElement.style.outline = "0rem solid #CB535B";

    // Remove the tabName-colorId combination from storedData
    var tabNameWithColorId = tabName + "-" + colorId + "-" + price;
    storedData.tabName = storedData.tabName.filter(name => name !== tabNameWithColorId);
  } else {
    btnElement.textContent = "Remove";
    colorElement.style.outline = ".25rem solid #CB535B";

    // Add the new tabName-colorId combination to the tabName array in storedData
    var tabNameWithColorId = tabName + "-" + colorId + "-" + price;
    storedData.tabName = storedData.tabName || [];
    if (!storedData.tabName.includes(tabNameWithColorId)) {
      storedData.tabName.push(tabNameWithColorId);
    }
  }

  // Store the updated data back in localStorage
  localStorage.setItem("customData", JSON.stringify(storedData));
  
  // If the tabName array is empty, remove the entire customData from local storage
  if (storedData.tabName.length === 0) {
    localStorage.removeItem("customData");
  }
}
